import React from 'react';

import { useFeature } from 'common/hooks/useFeature';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import FEATURES from 'src/core/constants/features';
import { routes, routeFor } from 'src/core/constants/routes';

import { NavLink } from '../NavLink/NavLink';

type Props = Readonly<{
  company: {
    id: string;
  };
}>;

export const BudgetsLink = ({ company }: Props) => {
  const { t } = useTranslation('global');
  const hasBudgetsByDimensionsFeature = useFeature(
    FEATURES.BUDGETS_BY_DIMENSIONS,
  );

  const budgetRoute = hasBudgetsByDimensionsFeature
    ? routes.BUDGETS_V2.path
    : routes.BUDGETARY_EXERCISES.path;

  const activePaths = hasBudgetsByDimensionsFeature
    ? [routes.BUDGETS_V2.path, routes.BUDGET_V2_OVERVIEW.path]
    : [routes.BUDGET_OVERVIEW.path, routes.BUDGETARY_EXERCISES.path];

  return (
    <NavLink
      href={routeFor(budgetRoute, {
        company: company.id,
      })}
      activePaths={activePaths}
      iconName="chart-pie"
    >
      {t('budget.mainMenuItem')}
    </NavLink>
  );
};
